/**
 * Quién ve «Mantenimiento» en Configuración y puede entrar a esa pantalla.
 *
 * Espejo de `maintenance-operators.ts` (core). Acá solo decide si se MUESTRA; el que
 * acepta o rechaza activar y desactivar es el servidor. Igual que con los perfiles
 * reservados (`reserved-profile.util.ts`): una lista corta de correos concretos y no un
 * permiso, porque esto saca de la plataforma a todo el mundo.
 *
 * OJO: en core la lista se puede pisar por ambiente con `MAINTENANCE_OPERATORS`. Si se
 * hace, hay que cambiarla también acá o el menú no aparece.
 */
export const MAINTENANCE_OPERATORS: readonly string[] = ['gonzalezjhonner@hotmail.com'];

export function canOperateMaintenance(email: unknown): boolean {
  const correo = String(email ?? '').trim().toLowerCase();
  return correo.length > 0 && MAINTENANCE_OPERATORS.some((c) => c.toLowerCase() === correo);
}
